
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/start-here/core-technology-discussions/komodo-sdk",
      function () {
        return require("private-next-pages/docs/start-here/core-technology-discussions/komodo-sdk/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/start-here/core-technology-discussions/komodo-sdk"])
      });
    }
  